import {FastAPIServiceError} from '@chekin/core';

export function deriveAuthFailureReason(error?: FastAPIServiceError): string {
  const raw = Array.isArray(error?.detail) ? error?.detail?.[0]?.msg : error?.detail;
  const detail = (raw || error?.message || '').trim().toLowerCase();

  if (!detail) return 'server';
  if (detail.includes('email already registered')) return 'email_already_registered';
  if (detail.includes('invalid credentials')) return 'invalid_credentials';
  if (detail.includes('invalid code')) return 'invalid_code';
  if (detail.includes('expired')) return 'expired';
  if (detail.includes('user not found')) return 'user_not_found';
  return 'server';
}
